import request from '@utils/request'

export function fetchGrants(params) {
  return request({
    url: `/admin/acs/grant`,
    params,
  })
}

export function fetchGrant(seq) {
  return request({
    url: `/admin/acs/grant/${seq || 0}`,
    method: 'get',
  })
}

export function createGrant(data) {
  return request.post('/admin/acs/grant', data)
}

export function updateGrant(data) {
  return request.put(`/admin/acs/grant/${data.seq}`, data)
}

export function deleteGrant(seq) {
  return request.delete(`/admin/acs/grant/${seq}`)
}

export function fetchGrantRoles(grant_seq) {
  return request({
    url: `/admin/acs/grant/${grant_seq || 0}/role`,
  })
}

export function fetchGrantRole(grant_seq, seq) {
  return request({
    url: `/admin/acs/grant/${grant_seq || 0}/role/${seq || 0}`,
    method: 'get',
  })
}

export function createGrantRole({ grant_seq, ...data }) {
  return request.post(`/admin/acs/grant/${grant_seq || 0}/role/`, data)
}

export function deleteGrantRole(grant_seq, seq) {
  return request.delete(`/admin/acs/grant/${grant_seq || 0}/role/${seq}`)
}

export function fetchGrantMemberList(params) {
  return request({
    url: '/admin/acs/grant-member',
    method: 'get',
    params,
  })
}

export function fetchGrantMember(seq) {
  return request({
    url: `/admin/acs/grant-member/${seq || 0}`,
    method: 'get',
  })
}

export function createGrantMember(data) {
  return request.post(`/admin/acs/grant-member/`, data)
}

export function deleteGrantMember(seq) {
  return request.delete(`/admin/acs/grant-member/${seq}`)
}

export function fetchRoles(params) {
  return request({
    url: `/admin/acs/role`,
    params,
  })
}

export function fetchRole(seq) {
  return request({
    url: `/admin/acs/role/${seq || 0}`,
    method: 'get',
  })
}

export function createRole(data) {
  return request.post('/admin/acs/role', data)
}

export function updateRole(data) {
  return request.put(`/admin/acs/role/${data.seq}`, data)
}

export function deleteRole(seq) {
  return request.delete(`/admin/acs/role/${seq}`)
}
